import React, { useEffect, useState } from 'react'
import styles from './style.module.scss'
import { FormWrapper } from '@Root/HOCs'
import { Field } from '@Root/components'
import { useError, useToggle } from '@Root/hooks'

const titles = { onEdit: 'Edit Student Initiatives', onRead: 'Student Initiatives Details', onCreate: 'Create Student Initiatives' }
export const StudentInitiativesForm = ({
  canEdit,
  canDelete,
  onDelete,
  onSave,
  onCancel,
  isNew,
  initialValue,
  isLoading,
  isSuccess,
  options,
  descriptions,
  onOpenDescriptionModal,
}) => {
  const [data, setData] = useState({})
  const { errors, setError, onClear: onClearError } = useError()
  const [isEditable, toggleEditable] = useToggle(Boolean(isNew))

  useEffect(() => {
    if (isSuccess) toggleEditable()
  }, [isSuccess])

  useEffect(() => {
    if (initialValue) setData(initialValue)
  }, [initialValue])

  const validateForm = () => {
    const { type_id } = data
    if (!type_id) {
      setError('type_id', 'Required')
      return false
    }
    onClearError()
    return true
  }

  const onChangeValue = field => value => {
    setData(prevState => ({ ...prevState, [field]: value }))
  }

  const onCancelEditMode = () => {
    onChangeMode()
    setData(initialValue)
  }

  const onChangeMode = () => {
    toggleEditable()
  }

  const onSubmitForm = () => {
    if (!validateForm()) return
    onSave(data)
  }

  const onCancelEdit = () => {
    if (!isNew) {
      onCancelEditMode()
      onClearError()
      return
    }
    onCancel()
  }

  const { type_id, id } = data
  const { student_initiative_types } = options
  const { onEdit, onRead, onCreate } = titles
  return (
    <div className={styles.form}>
      <FormWrapper
        buttons={isEditable ? ['cancel', ...(canDelete ? ['delete'] : []), 'save'] : []}
        buttonsNames={[{ button: 'delete', name: 'Delete this student initiative' }]}
        buttonsAreDisabled={isLoading}
        isSpinning={isLoading}
        clickCancelButtonHandler={onCancelEdit}
        clickDeleteButtonHandler={onDelete}
        clickSaveButtonHandler={onSubmitForm}
        editTitle={onEdit}
        readTitle={onRead}
        createTitle={onCreate}
        clickToggleEditModeButtonHandler={onChangeMode}
        isEditable={isEditable}
        canEdit={canEdit}
        isCreate={isNew}
        idForm={id ? `student_initiatives_${id}` : null}
        isSuccess={isSuccess}
      >
        <div className={styles.grid}>
          <div className={styles.column}>
            <div className={styles.row}>
              <Field
                label={'Student initiative'}
                classNames={!isEditable ? ['borderless'] : []}
                style={{ width: 260 }}
                value={type_id}
                onChange={onChangeValue('type_id')}
                placeholder='Student initiative'
                isDisabled={!isEditable}
                maxLength={3}
                field={'select'}
                options={student_initiative_types}
                optionsStyle={{ width: 260 }}
                isRequired
                error={errors.type_id}
                description={descriptions?.type_id}
                onOpenDescriptionModal={onOpenDescriptionModal}
              />
            </div>
          </div>
        </div>
      </FormWrapper>
    </div>
  )
}
